import { useTranslation } from 'react-i18next'
import { CheckCircleIcon } from '@heroicons/react/24/outline'

import Modal from '@components/Modal'
import { StudentListHeader } from '@components/StudentListItem'
import type { Student } from '@/services/contribution/contribution'
import { sort } from '@/util/sorters'

interface StudentConfirmationModalProps {
  show: boolean
  students: Student[]
  onAddAnother: () => void
  onContinue: () => void
}

export default function StudentConfirmationModal({
  show,
  students,
  onAddAnother,
  onContinue,
}: StudentConfirmationModalProps) {
  const { t } = useTranslation()

  return (
    <Modal
      variant='success'
      show={show}
      title={t('content.components.wizard.confirm_students_modal_title')}
      icon={<CheckCircleIcon aria-hidden='true' className='size-6 text-success' />}
      cancelLabel={t('content.components.wizard.confirm_students_modal_add_another_button')}
      buttonLabel={t('content.components.wizard.confirm_students_modal_continue_button')}
      onConfirm={onContinue}
      onClose={onAddAnother}
    >
      <div className='flex flex-col gap-2'>
        <div className='text-sm font-semibold text-gray-700'>
          {t('content.components.wizard.confirm_students_modal_count', { count: students.length })}
        </div>
        <div className='overflow-x-auto'>
          <table className='min-w-full divide-y divide-gray-300'>
            <thead>
              <StudentListHeader />
            </thead>
            <tbody className='divide-y divide-solid divide-gray-200'>
              {sort(students, 'STUDENT_ASC').map((student) => (
                <tr key={student.id ?? undefined}>
                  <td className='whitespace-nowrap py-3 px-1 text-sm text-gray-500 text-left'>
                    {student.firstName} {student.lastName}
                  </td>
                  <td className='whitespace-nowrap py-3 px-1 text-sm text-gray-500 text-left'>
                    {student?.classroom?.name ?? 'Other'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  )
}
